import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ToggleButtonListItem from '../../../../../../list-items/ToggleButtonListItem';
import { GLOW_TYPE } from '../../../../Preview/PreviewDisplayConstants';

const glowTypesOptions = [
    {value: GLOW_TYPE.OUTER, text: 'Outer'},
    {value: GLOW_TYPE.INNER, text: 'Inner'},
];

const VisualizerGlowTypeListItem = (props) => {
    const { glowSettingsGlowType, updateVisualizerSettings } = props;
    
    const onGlowTypeChange = (value) => {
        updateVisualizerSettings({ 
            glowSettings:  { glowType: value }
        });
    };
    
    return (
        <ToggleButtonListItem
            text='Type'
            value={glowSettingsGlowType}
            onChange={onGlowTypeChange}
            options={glowTypesOptions}
            toolTip={
                <>
                    <p>OUTER: The glow appears around the outside of the visualizer. The visualizer colors appear exactly as they are defined in the "COLORS" section.</p>
                    <p>INNER: The glow appears inside the visualizer. This can cause visualizer colors to appear brighter and bleed into each other.</p>
                </>
            }
        />
    );
};

const mapStateToProps = (state) => {
    const { glowType: glowSettingsGlowType } = state.createPreview.present.videoSettings.visualizer.glowSettings;
    return { glowSettingsGlowType };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerGlowTypeListItem);